

































































import { SbpDefaultModalVue } from "fs-pb-vue2/vueModels/settings/SbpDefaultModalVue";
import { Component } from "vue-property-decorator";
import VerifyBox from "@/components/app/VerifyBox.vue";
import BackLink from "@/components/app/BackLink.vue";
import IOperationService from "fs-pb-vue2/services/operations/IOperationService";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { container } from "@/inversify.config";
import { SbpDeleteDefaultModel } from "fs-pb-vue2/models/settings/sbpDeleteDefaultModel";
import { OperationRequestData } from "fs-pb-vue2/data/operationRequestData";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data/enums/declarationPropertiesTypes";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";

@Component({
  components: { VerifyBox, BackLink }
})
export default class SbpDeleteDefaultModal extends SbpDefaultModalVue {

  private verificationStartTime: number = 0;

  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.SbpDeleteDefaultService);
    this.OperationModel = (await this.service.init(
      this.configStore,
      this.personStore
    )) as SbpDeleteDefaultModel;

    this.verificationStartTime = Date.now();

    this.loading = false;
  }

  async mounted() {
    await this.init();
  }

  async handleSubmit(): Promise<void> {
    if (this.isConfirm && this.needConfirm) {
      // Проверка времени ожидания (3 минуты)
      if ((Date.now() - this.verificationStartTime) > 180000) {
        await this.alertService.error("Отказано. Время ожидания операции истекло. Начните операцию заново.");
        this.destroyForm();
        return;
      }

      if (!this.OperationModel.VerifyCode) {
        await this.alertService.error("Не введен код подтверждения");
        return;
      }

      if (this.OperationModel.VerifyCode.length < 6) {
        await this.alertService.error("Неверный код подтверждения. Должно быть 6 цифр");
        return;
      }
    }

    this.next();
  }

  async repeatCodeSbp(): Promise<void> {
    const ord = new OperationRequestData();
    ord.respondentCode = this.OperationModel.RespondentCode;

    ord.setProperty("sbpID", "", DeclarationPropertiesTypes.String);
    ord.setProperty("phone", "", DeclarationPropertiesTypes.String);
    ord.setProperty("delete", true, DeclarationPropertiesTypes.Boolean);

    await OperationsApi.executeOperationSendAsync(ord);
  }

}
